<template>
  <section class="portfolio d-flex flex-column align-content-center">
    <div class="text-white py-5 margin-center px-3 text-responsive text-center">
      Nothing to see here at the moment. In the meantime, please enjoy this
      alpaca
    </div>
    <div class="margin-center">
      <img
        class="img-fluid pb-4"
        src="@/assets/img/alpaca.jpeg"
        alt="alpaca"
        srcset=""
      />
    </div>
  </section>
</template>

<script>
export default {
  data: function () {
    return {
      number: 4,
    };
  },
};
</script>

<style>
.img-fluid {
  max-width: 15rem;
}

.text-responsive {
  font-size: 1rem;
}

@media (min-width: 330px) {
  .img-fluid {
    max-width: 20rem;
  }
}

@media (min-width: 680px) {
  .img-fluid {
    max-width: 40rem;
  }

  .text-responsive {
    font-size: 2rem;
  }
}

.margin-center {
  margin: 0 auto;
}
</style>
